export const secondsToTime = (seconds: number) => {
  seconds = Number(seconds);

  let day = Math.floor(seconds / (3600 * 24));
  let hour = Math.floor((seconds % (3600 * 24)) / 3600);
  let minute = Math.floor((seconds % 3600) / 60);
  let second = Math.floor(seconds % 60);

  const obj = {
    dia: day,
    hora: hour,
    minuto: minute,
    segundo: second,
  };

  return obj;
};
